var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99903 17C10.1028 17 10.9981 16.1047 10.9981 15H6.99997C6.99997 16.1047 7.89528 17 8.99903 17ZM15.73 12.3216C15.1262 11.6728 13.9965 10.6969 13.9965 7.5C13.9965 5.07188 12.294 3.12812 9.9984 2.65125V2C9.9984 1.44781 9.5509 1 8.99903 1C8.44716 1 7.99966 1.44781 7.99966 2V2.65125C5.70404 3.12812 4.00154 5.07188 4.00154 7.5C4.00154 10.6969 2.87186 11.6728 2.26811 12.3216C2.08061 12.5231 1.99748 12.7641 1.99905 13C2.00248 13.5125 2.40467 14 3.00217 14H14.9959C15.5934 14 15.9959 13.5125 15.999 13C16.0006 12.7641 15.9175 12.5228 15.73 12.3216Z",
    fill: "#503EB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.30e42c333400386e6815dd60149e56b9.svg";
export { ForwardRef as ReactComponent };